import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WarehouseTimeZoneService } from './warehouse-time-zone.service';

@Pipe({
  name: 'warehouseTimeZoneAsync',
  pure: false,
})
export class WarehouseTimeZoneAsyncPipe implements PipeTransform {

  constructor(private readonly _warehouseTimeZoneService: WarehouseTimeZoneService) {
  }

  transform(value: DateTime, warehouseId: number): Observable<DateTime> {
    return this._warehouseTimeZoneService.getTimeZone$(warehouseId).pipe(map(timeZone => value?.setZone(timeZone)));
  }

}
